<template>
  <v-card>
    <!-- tab control -->
    <v-card class="d-flex justify-space-around align-center">
      <div bottom class="text-h5">Cuenta Corriente Clientes</div>
    </v-card>
    <!-- tab0 list -->
    <v-card-text>
      <v-card>
        <!-- advanced filter -->
        <v-toolbar>
          <v-text-field
            disabled
            hide-details
            v-model="client.client_name"
            label="Cliente"
          >
            <v-icon
              slot="prepend"
              class="enabled-icon"
              @click="clientSearchClick"
            >
              mdi-magnify
            </v-icon>
            <!-- eslint-disable -->
            <v-icon
              slot="append-outer"
              class="enabled-icon"
              @click="clientSelected(null)"
            >
              mdi-close
            </v-icon>
            <!-- eslint-enable -->
          </v-text-field>
          <v-spacer></v-spacer>
          <v-autocomplete
            label="Comercial"
            :items="commercialPersonItems"
            hide-details
            hide-no-data
            hide-selected
            item-text="name"
            item-value="commercial_person"
            return-object
            @change="commercialPersonSelected($event)"
            ref="commercialPersonAutocomplete"
            prepend-icon="mdi-close"
            @click:prepend="clearAutocomplete('commercialPersonAutocomplete')"
          ></v-autocomplete>
          <v-spacer></v-spacer>
          <v-autocomplete
            label="Agrupamiento"
            :items="groupItems"
            hide-details
            hide-no-data
            hide-selected
            item-text="description"
            item-value="id"
            v-model="selectedGroup"
            return-object
            @change="groupSelected($event)"
          ></v-autocomplete>
          <v-spacer></v-spacer>
          <v-autocomplete
            label="Vencimiento"
            :items="dayItems"
            hide-details
            hide-no-data
            hide-selected
            item-text="description"
            item-value="id"
            v-model="selectedDay"
            return-object
            @change="daySelected($event)"
          ></v-autocomplete>
          <v-progress-linear
            :active="loading"
            indeterminate
            absolute
            bottom
          ></v-progress-linear>
        </v-toolbar>
      </v-card>
      <div v-show="pivotLoaded" id="pivot-container" class="mt-2"></div>
    </v-card-text>

    <!-- component for magnify searchs -->
    <paginated-search-dialog
      v-if="clientShowSearch"
      :show="clientShowSearch"
      :title="clientSearchOptions.title"
      :endpoint="clientSearchOptions.endpoint"
      :ordering="clientSearchOptions.ordeting"
      :searchLabel="clientSearchOptions.searchLabel"
      :headers="clientSearchOptions.headers"
      :filterString="clientSearchOptions.filterString"
      :canEdit="false"
      :canAdd="false"
      :searchOnURL="clientSearchOptions.searchOnURL"
      @itemSelected="clientSelected($event)"
      @cancel="searchCanceled"
    >
    </paginated-search-dialog>
  </v-card>
</template>
<script>
import WebDataRocks from "webdatarocks";
import "webdatarocks/webdatarocks.min.css";
import "webdatarocks/webdatarocks.toolbar";
import wdrEs from "@/assets/webDataRocksEs.json";
import PaginatedSearchDialog from "@/components/PaginatedSearchDialog.vue";
import XLSX from "xlsx";

export default {
  name: "ClientCurrentAccount",

  components: {
    PaginatedSearchDialog
  },

  data() {
    return {
      currentLevel: -1,
      clientSearchOptions: {},
      clientShowSearch: false,
      client: {
        client_code: "",
        client_name: "",
        client_id: 0,
        dealers_quantity: 0
      },
      campaign_id: 0,
      groupItems: [
        { id: 0, description: "Detallado" },
        { id: 1, description: "Cliente" },
        { id: 2, description: "Cliente/Distribuidor" }
      ],
      dayItems: [
        { id: -1, description: "Todos" },
        { id: 0, description: "Vencidos" },
        { id: 15, description: "a vencer en 15 días" },
        { id: 30, description: "a vencer en 30 días" },
        { id: 45, description: "a vencer en 45 días" },
        { id: 60, description: "a vencer en 60 días" },
        { id: 90, description: "a vencer en 90 días" },
        { id: 180, description: "a vencer en 180 días" },
        { id: 360, description: "a vencer en 360 días" }
      ],
      pivot: null,
      pivotLoaded: false,
      loading: true,
      commercialPersonItems: [],
      filterCommercialPerson: null,
      filterGroup: null,
      selectedGroup: null,
      filterDay: null,
      selectedDay: null
    };
  },

  methods: {
    //Reading data from API method.
    async readDataFromAPI() {
      try {
        this.loading = true;
        /* eslint-disable */
        if (this.campaign_id != 0 && (this.client.client_id != 0 || this.filterCommercialPerson)) {
          let endpoint =
            "/data/account_receivables_report/" +
            this.campaign_id.toString() +
            "/" +
            /* eslint-disable */
            (this.client ? this.client.client_id.toString() : "0") +
            "/";
            /* eslint-disable */
            switch (this.filterCommercialPerson ? this.filterCommercialPerson.commercial_type_level : 0) {
              case 0:
                endpoint = endpoint + "0/0/0";
                break;
              case 1:
                /* eslint-disable */
                endpoint = endpoint + this.filterCommercialPerson.commercial_id.toString() + "/0/0";
                break;
              case 2:
                /* eslint-disable */
                endpoint = endpoint + "0/" + this.filterCommercialPerson.commercial_id.toString() + "/0";
                break;
              case 3:
                /* eslint-disable */
                endpoint = endpoint + "0/0/" + this.filterCommercialPerson.commercial_id.toString();
                break;
            }
          endpoint = endpoint + "/" + this.filterGroup.id.toString();
          endpoint = endpoint + "/" + this.filterDay.id.toString();

          let response = await this.$bRoot.search(endpoint);

          let title =
            "Cuenta corriente pendiente " +
             /* eslint-disable */
             (this.client ? " cliente " + this.client.client_name : ' clientes del comercial ' + this.filterCommercialPerson.name);
          await this.loadPivotTable(response.data, title);
          this.pivotLoaded = true;
        } else {
          this.pivotLoaded = false;
          this.unloadPivotTable();
        }
      } catch (error) {
        if (!this.$bRoot.errors) {
          this.$bRoot.setError(error);
        }
      } finally {
        this.loading = false;
      }
    },

    clientSearchClick() {
      this.clientSearchOptions = {
        headers: [
          { text: "Código", value: "client_data.code", sortable: false },
          {
            text: "Identificación",
            value: "client_data.identification",
            sortable: false
          },
          { text: "Nombre", value: "client_data.name", sortable: false },
          {
            text: "Categoría",
            value: "client_data.category_object.description",
            sorteable: false
          }
        ],
        title: "Cliente...",
        endpoint: "/data/clients_hierarchy/" + this.campaign_id.toString(),
        ordering: null,
        searchLabel: "Código/CUIT/Nombre",
        filterString: null,
        selected: "clientSelected",
        searchOnURL: true
      };
      this.clientShowSearch = true;
    },

    async clientSelected(client) {
      if (client) {
        this.clearAutocomplete("commercialPersonAutocomplete");
        this.client = {
          client_code: client.client_data.code,
          client_name: client.client_data.name,
          client_id: client.client_data.id,
          dealers_quantity: client.dealers_quantity
        };
      } else {
        this.client = {
          client_code: "",
          client_name: "",
          client_id: 0,
          dealers_quantity: 0
        };
      }
      this.searchCanceled();
      await this.readDataFromAPI();
    },

    async commercialPersonSelected(item) {
      await this.clientSelected(null);
      this.filterCommercialPerson = item;
      await this.readDataFromAPI();
    },

    async groupSelected(group) {
      this.filterGroup = group;
      await this.readDataFromAPI();
    },

    async daySelected(day) {
      this.filterDay = day;
      await this.readDataFromAPI();
    },

    async clearAutocomplete(field) {
      this.$refs[field].internalValue = [];
      switch (field) {
        case "commercialPersonAutocomplete":
          this.filterCommercialPerson = null;
          break;
      }
      await this.readDataFromAPI();
    },

    async searchCanceled() {
      this.clientShowSearch = false;
      this.clientSearchOptions = {};
    },

    async loadPivotTable(data, title) {
      this.pivot = null;
      /*Crear Pivot Table*/
      let rows = [
        { uniqueName: "cliente_nombre" },
      ];

      if (this.client.client_id == 0) {
        rows.push( { uniqueName: "ranking_vencimientos", caption: "ranking" } );
      }

      if (
        this.currentLevel <= 2 && /*Distribuidor solo se muestra a DIR/GTC/RTC*/
        !(
          this.currentLevel >= 0 &&
          this.currentLevel <= 2 &&
          this.client.client_id == 0 &&
          this.filterCommercialPerson.commercial_type_level < 2
        ) &&
        (this.selectedGroup.id == 0 || this.selectedGroup.id == 2)
      ) {
        rows.push( { uniqueName: "distribuidor_nombre", caption: "distribuidor" } );
      }

      if (
        !(
          this.currentLevel >= 0 &&
          this.currentLevel <= 2 &&
          this.client.client_id == 0 &&
          this.filterCommercialPerson.commercial_type_level < 2
        ) &&
        (this.selectedGroup.id == 0)
      ) {
        rows.push( { uniqueName: "comprobante" } );
        rows.push( { uniqueName: "descripcion" } );
        rows.push( { uniqueName: "fecha" } );
        rows.push( { uniqueName: "vencimiento" } );
        rows.push( { uniqueName: "origen" } );
        rows.push( { uniqueName: "origen_cultivo", caption: "cultivo" } );
        rows.push( { uniqueName: "origen_medio_pago", caption: "medio de pago" } );
      }

      let measures = [
        {
          uniqueName: "USD Vencidos",
          caption: "USD Vencidos",
          individual: true,
          formula: '"saldo_vencido_me"',
          aggregation: "sum",
          format: "f_importe"
        },
        {
          uniqueName: "USD No Vencidos",
          caption: "USD No Vencidos",
          individual: true,
          formula: '"saldo_no_vencido_me"',
          aggregation: "sum",
          format: "f_importe"
        },
        {
          uniqueName: "ARS a Favor",
          caption: "ARS a Favor",
          individual: true,
          formula: '"saldo_a_favor_ml"',
          aggregation: "sum",
          format: "f_importe"
        }
      ];

      this.pivot = new WebDataRocks({
        container: "#pivot-container",
        toolbar: true,
        beforetoolbarcreated: this.customizeToolbar,
        reportcomplete: this.expandsPivotTable,
        global: {
          localization: wdrEs
        },
        report: {
          options: {
            showAggregationLabels: false,
            grid: {
              type: "flat",
              showHeaders: false,
              showTotals: "on",
              showGrandTotals: "on",
              title: title
            },
            configuratorButton: false
          },
          dataSource: {
            data: data
          },
          slice: {
            rows: rows,
            columns: [{ uniqueName: "Measures" }],
            measures: measures,
            expands: {
              expandAll: false
            }
          },
          formats: [
            {
              name: "f_importe",
              thousandsSeparator: ".",
              decimalSeparator: ",",
              decimalPlaces: 2,
              currencySymbol: "",
              currencySymbolAlign: "left",
              nullValue: "",
              textAlign: "right",
              isPercent: false
            },
            {
              name: "f_valor",
              thousandsSeparator: ".",
              decimalPlaces: 0,
              currencySymbol: "",
              currencySymbolAlign: "left",
              nullValue: "",
              textAlign: "right",
              isPercent: false
            }
          ]
        }
      });
    },

    unloadPivotTable() {
      this.pivot = null;
    },

    customizeToolbar(toolbar, sr = this) {
      var tabs = toolbar.getTabs();
      tabs.forEach((tab, index) => {
        if (!(tab.id == "wdr-tab-fullscreen" || tab.id == "wdr-tab-export")) {
          delete tabs[index];
        }
      });
      toolbar.getTabs = function(
        dd = (() => {sr.DownloadDetail()}),
        ea = (() => {sr.expandAllPivotTable()}),
        ){
        tabs.unshift({
          id: "wdr-tab-expand-all",
          title: "Expandir",
          icon: '<i class="mdi mdi-24px mdi-expand-all-outline"></i>',
          handler: ea
        });
        if (
          sr.client.client_id > 0 && ((sr.currentLevel >= 0 && sr.currentLevel <= 2) || sr.client.dealers_quantity === 1)
        ) {
          tabs.unshift({
            id: "wdr-tab-download-detail",
            title: "Detallado",
            icon: this.icons.export_excel,
            handler: dd
          });
        }
        return tabs;
      };
    },

    expandsPivotTable() {
      this.pivot.expandData("cliente_agrupado_nombre");
      this.pivot.expandData("cliente_nombre");
      this.pivot.expandData("distribuidor_nombre");
    },

    expandAllPivotTable() {
      this.pivot.expandAllData();
    },

    async DownloadDetail() {
      try {
        let filename =
          "historico_cuenta_corriente_" +
          this.client.client_code +
          "_" +
          this.$moment().format("DD/MM/YYYY h:mm a") +
          ".xlsx";

        this.loading = true;
        let endpoint =
          "/data/account_receivables_download/" +
          this.campaign_id.toString() +
          "/" +
          this.client.client_id.toString();

        // eslint-disable-next-line
        let raw = await this.$bRoot.search(endpoint, null, null, null, null);
        if (raw.data) {
          let datosWS = XLSX.utils.json_to_sheet(raw.data);
          let wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, datosWS, "datos");
          XLSX.writeFile(wb, filename);
        }
      } catch (error) {
        if (!this.$bRoot.errors) {
          this.$bRoot.setError(error);
        }
      } finally {
        this.loading = false;
      }
    }
  },

  async mounted() {
    try {
      var main_container = document.getElementById("app");
      main_container.classList.remove("home");

      this.currentLevel = this.$bRoot.auth.current_level;
      //get campaign
      // eslint-disable-next-line
      let campaigns = await this.$bRoot.searchAll("/data/campaigns", null, "code", "orders_enabled__in=S,D");
      for (let c in campaigns) {
        this.campaign_id = campaigns[c].id;
        break;
      }

      //load commercial persons
      let commercialPersons = await this.$bRoot.searchAll(
        "/data/commercial_persons_hierarchy",
        null,
        "name",
        "commercial_type_level__lt=4"
      );
      this.commercialPersonItems = commercialPersons;

      //Group Default Value
      this.filterGroup = this.groupItems[0];
      this.selectedGroup = this.groupItems[0];

      //Day Default Value
      this.filterDay = this.dayItems[0];
      this.selectedDay = this.dayItems[0];
    } catch (error) {
      if (!this.$bRoot.errors) {
        this.$bRoot.setError(error);
      }
    } finally {
      this.loading = false;
    }
  }
};
</script>
<style>
.wdr-credits {
  display: none;
}
.enabled-icon {
  pointer-events: auto;
  color: black;
}
</style>
